import { Box, Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { IMaterial, ICVMaterialInformationFormSection, IComboBoxOption, MaterialContext } from "../../interfaces";
import { Sort, Values } from "../../utils";
import { AddFromInventoryDialog } from "../AddFromInventoryDialog";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { MaterialInputDialog } from "../MaterialInputDialog";
import { MaterialConsumableTableRow } from "./MaterialConsumableTableRow";
import { MaterialUpdateTableRow } from "./MaterialUpdateTableRow";
import { HistoricMaterialInformationAlert } from "../Shared/HistoricMaterialInformationAlert";

export const MaterialInformationForm: React.FC<ICVMaterialInformationFormSection> = ({
    entityId,
    status,
    materials,
    deleted,
    onUpdateMaterials,
    onConsumeMaterials,
    onRemoveMaterial,
    onImportComplete,
    readonly,
    isContractEnd,
    saving,
    ...props
}: ICVMaterialInformationFormSection) => {

    const [returnStatuses, setReturnStatuses] = useState<IComboBoxOption[]>([]);

    const [consumed, setConsumed] = useState<string[]>([]);


    const getMaterials = (statusId?: number) => {

        let clone = cloneDeep(materials);

        if (statusId)
            return clone.filter(x => x.statusId === statusId)

        Sort.materials(clone)

        return clone;
    }


    const consumeMaterial = (material: IMaterial, consume: boolean) => {

        let consumeList = cloneDeep(consumed);

        consumeList = consumeList.filter(x => x !== material.materialId);

        if (consume && material.materialId)
            consumeList.push(material.materialId);

        setConsumed(consumeList);
        onConsumeMaterials(consumeList);

    }

    const addMaterial = (material: IMaterial) => {

        let model = getMaterials();

        model.push(material);
        Sort.materials(model);

        onUpdateMaterials(model);
    }

    const removeMaterial = (material: IMaterial, qty: number) => {

        if (material.materialId === undefined) {
            let model = getMaterials();

            if (material.quantity === qty) {
                //remove entirely
                model = model.filter(x => JSON.stringify(x) !== JSON.stringify(material));
            }

            Sort.materials(model);
            onUpdateMaterials(model);
        }

        let removedMaterial = cloneDeep(material);
        removedMaterial.quantity = qty;

        onRemoveMaterial(removedMaterial);
    }

    const updateMaterial = (prev: IMaterial, material: IMaterial) => {


        let model: IMaterial[] = [];

        getMaterials().forEach(m => {
            if (JSON.stringify(m) === JSON.stringify(prev)) {

                model.push(material);

            } else model.push(m)
        });

        onUpdateMaterials(model);

    }

    const getSubtractedQuantity = (materialId: string | undefined) => {

        let subtracted = 0;

        deleted.filter(x => x.materialId === materialId)
            .forEach(el => {
                subtracted += (el.quantity ?? 0)
            });

        return subtracted;
    }

    const EndContractMaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell><strong>Consumed?</strong></TableCell>
            </TableRow>
        </TableHead>);
    }

    const UpdateMaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Expected Return Condition</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>);
    }

    useEffect(() => {
        if (returnStatuses.length === 0)
            Values.setValues("expectedmaterialreturnstates", setReturnStatuses);
    }, [materials, returnStatuses.length]);

    return (
        <Card>

            <FormSectionHeader label="Materials" saving={saving} />

            <CardContent>

                <Grid container spacing={4}>
                    {materials.length > 0 ?

                        <Grid item xs={12}>
                            <Box><HistoricMaterialInformationAlert /></Box>

                            <TableContainer>
                                <Table>

                                    {isContractEnd ? <EndContractMaterialTableHead />
                                        : <UpdateMaterialTableHead />

                                    }

                                    <TableBody>
                                        {materials.length > 0 && materials.map((material, i) => isContractEnd ?

                                            <MaterialConsumableTableRow
                                                key={i}
                                                material={material}
                                                readOnly={readonly}
                                                consumed={consumed}
                                                onConsume={(consume) => consumeMaterial(material, consume)}
                                                onUndo={undefined}

                                            />
                                            :
                                            <MaterialUpdateTableRow
                                                key={i}
                                                material={material}
                                                subtractQuantity={getSubtractedQuantity(material.materialId)}
                                                returnStatuses={returnStatuses}
                                                onUpdate={(m: IMaterial, s: any) => { updateMaterial(material, m) }}
                                                onRemove={(qty: number) => removeMaterial(material, qty)}
                                                readOnly={readonly}
                                            />
                                        )
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid> : <br />}
                </Grid>

                {!readonly && !isContractEnd &&
                    <Grid container>

                        <MaterialInputDialog
                            entity={{ id: entityId ?? "", type: "CONTRACTVARIATION" }}
                            context={MaterialContext.MaterialTable}
                            onSubmitMaterial={(material) => addMaterial(material)}
                            onImportComplete={onImportComplete}
                            focus={materials.length === 0}
                        />
                        <AddFromInventoryDialog
                            entityName="Contract Variation"
                        />
                    </Grid>
                }

            </CardContent>
        </Card>
    );
}